//恒大江海定制页面路由
export default [
  //行业应用图文版(恒大江海)
  {
    path: "/:lang/Corp/HDJH/Application/ByImg",
    name: "ApplicationByImg",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/HDJH/ApplicationImg.vue"),
  },
  //泵类型动画介绍
  {
    path: "/:lang/Corp/HDJH/PumpAnimationIntr",
    name: "PumpAnimationIntr",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/HDJH/PumpAnimationIntr.vue"),
  },
];
